module.exports = __webpack_public_path__ + "static/img/CModelIMG1.b1fae69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/CModelIMG1.png
// module id = LR71
// module chunks = 1